import React, { FC } from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LinkedIn from '@material-ui/icons/LinkedIn';
import Twitter from '@material-ui/icons/Twitter';
import Facebook from '@material-ui/icons/Facebook';
import YouTube from '@material-ui/icons/YouTube';
import Instagram from '@material-ui/icons/Instagram';

import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(3),
  },
  twitter: { color: theme.custom.networks.twitter },
  linkedin: { color: theme.custom.networks.linkedin },
  facebook: { color: theme.custom.networks.facebook },
  youtube: { color: theme.custom.networks.youtube },
  instagram: { color: theme.custom.networks.instagram },
  inactive: {
    color: theme.palette.action.disabled,
  },
}));

interface IProps {
  active: boolean;
  provider: any;
}

const icons = {
  linkedin: LinkedIn,
  twitter: Twitter,
  facebook: Facebook,
  youtube: YouTube,
  instagram: Instagram,
};

const MaterialSVGIcon: FC<IProps> = ({ provider, active }) => {
  const classes = useStyles();

  return (
    <SvgIcon
      component={icons[provider]}
      fontSize="large"
      className={classNames(classes.icon, active ? classes['name'] : classes.inactive)}
    />
  );
};

export default MaterialSVGIcon;
